import {
  collection,
  getDocs,
  doc,
  getDoc,
  onSnapshot,
} from "firebase/firestore";
import { dbAML as db } from "../../../../backend/firebaseConfig";

// Finds the *first* Experian Response doc ref for this check
export async function getExperianResponseDocRef(ownerEmail, checkId) {
  if (!ownerEmail || !checkId) throw new Error("Missing ownerEmail/checkId");

  const path = `AML Checks/${ownerEmail}/Checks/${checkId}/Experian Response`;
  const colRef = collection(db, path);
  const snap = await getDocs(colRef);

  if (snap.empty) throw new Error("No Experian Response doc found.");

  const first = snap.docs[0];
  return doc(db, colRef.path, first.id);
}

// ONE-OFF fetch (use this in your PDF/report)
export async function fetchPepSanReasonsByRef(ownerEmail, checkId) {
  const ref = await getExperianResponseDocRef(ownerEmail, checkId);
  const snap = await getDoc(ref);
  if (!snap.exists()) return {};
  return snap.data()?.reasonsByRef || {};
}

// REALTIME subscribe (use this in the UI)
export async function subscribePepSanReasonsByRef(ownerEmail, checkId, cb) {
  const ref = await getExperianResponseDocRef(ownerEmail, checkId);

  // initial + realtime
  return onSnapshot(
    ref,
    (snap) => {
      const next = snap.exists() ? snap.data()?.reasonsByRef || {} : {};
      cb(next);
    },
    (err) => {
    //   console.error("[subscribePepSanReasonsByRef] error:", err);
      cb({}); // safe fallback
    }
  );
}
